export function postalCodeLookup(postalCode: string) {
    const pcNumber = parseInt(postalCode)    
    if (((pcNumber >= 1000) && (pcNumber <= 2599)) || ((pcNumber >= 2619) && (pcNumber <= 2899)) ||
        ((pcNumber >= 2921) && (pcNumber <= 2999)))
        return 'New South Wales'
    else if (((pcNumber >= 200) && (pcNumber <= 299)) || ((pcNumber >= 2600) && (pcNumber <= 2618)) ||
            ((pcNumber >= 2900) && (pcNumber <= 2920)))
        return 'Australian Capital Territory'
    else if (((pcNumber >= 3000) && (pcNumber <= 3999)) || ((pcNumber >= 8000) && (pcNumber <= 8999)))
        return 'Victoria'
    else if (((pcNumber >= 4000) && (pcNumber <= 4999)) || ((pcNumber >= 9000) && (pcNumber <= 9999)))
        return 'Qeenisland'
    else if ((pcNumber >= 5000) && (pcNumber <= 5999))
        return 'South Australia'
    else if (((pcNumber >= 6000) && (pcNumber <= 6797)) || ((pcNumber >= 6800) && (pcNumber <= 6999)))
        return 'Western Australia'
    else if ((pcNumber >= 7000) && (pcNumber <= 7999))
        return 'Tasmania'
    else if ((pcNumber >= 800) && (pcNumber <= 999))
        return 'Nothern Territory'
    else
        return ''
    
}